export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13604.8a95fe7a.jpg";